export default {
    RASCUNHO: 'Não Formalizado',
    EM_FORMALIZACAO: 'Não Formalizado',
    FORMALIZADO: 'Formalizado',
    CANCELADO: 'Cancelado'
}
